import type { AppState } from '../../store/types';

export const getSelectedItemIds = (state: AppState): string[] | undefined =>
  state.navigationHistory.history[state.navigationHistory.history.length - 1]
    ?.selectedIds;
